// import axios from "axios";
// import { API_BASE_URL } from "../config/apiConfig";
// import { toast } from "react-toastify";

// let isRefreshing = false;
// let refreshSubscribers = [];
// let inFlightRequests = new Map();

// export const apiRequest = async (
//   method = "get",
//   url = "",
//   payload = { body: null, queries: null },
//   contentType = "application/json",
//   uploadProgress = () => {},
//   customHeader = {}
// ) => {
//   try {
//     let refresh_token = localStorage.getItem("refreshToken");
//     let access_token = localStorage.getItem("auth_token");

//     const requestKey = `${method.toLowerCase()}-${url}-${JSON.stringify(
//       payload
//     )}`;

//     if (inFlightRequests.has(requestKey)) {
//       return inFlightRequests.get(requestKey);
//     }

//     const cancelTokenSource = axios.CancelToken.source();

//     const instance = axios.create({
//       baseURL: API_BASE_URL,
//       headers: {
//         "Content-Type": contentType,
//         Accept: contentType,
//         ...customHeader,
//       },
//       cancelToken: cancelTokenSource.token,
//       onUploadProgress: (progressEvent) => {
//         const percentCompleted = Math.round(
//           (progressEvent.loaded * 100) / progressEvent.total
//         );
//         uploadProgress(percentCompleted);
//       },
//     });

//     // Add a request interceptor
//     instance.interceptors.request.use(
//       function (config) {
//         if (customHeader?.Authorization) {
//           config.headers[`Authorization`] = customHeader?.Authorization;
//         }
//         if (access_token && !customHeader?.Authorization) {
//           config.headers[`Authorization`] = "Bearer " + access_token;
//         }
//         return config;
//       },
//       function (error) {
//         return Promise.reject(error);
//       }
//     );

//     function refreshToken(data) {
//       // Implement your token refresh logic here and return a Promise with the new token
//       // For example, you might make a request to the server to get a new token
//       if (refresh_token) {
//         return axios
//           .post(API_BASE_URL + "/refreshToken", {
//             refreshToken: refresh_token,
//           })
//           .then((res) => {
//             if (res?.data?.status === 200) {
//               localStorage.setItem("auth_token", res?.data?.accessToken);
//               localStorage.setItem("refreshToken", res?.data?.refreshToken);
//               access_token = res?.data?.accessToken;
//               refresh_token = res?.data?.refreshToken;
//               onTokenRefreshed(res?.data?.accessToken);
//               return res?.data?.accessToken;
//             } else {
//               sessionStorage.clear();
//               localStorage.clear();
//               return Promise.reject("Sign out");
//             }
//           })
//           .catch((error) => {
//             sessionStorage.clear();
//             localStorage.clear();
//             return Promise.reject(error);
//           });
//       } else {
//         return Promise.reject("No refresh token available");
//       }
//     }

//     // Add a response interceptor
//     instance.interceptors.response.use(
//       (response) => response,
//       (error) => {
//         if (error?.response?.data?.invalidToken && url !== "verify-token") {
//           if (window.location?.pathname?.split("/").includes("admin")) {
//             // toast.warning("session time out");
//             window.location.href = window.location.origin + "/admin/signin";
//             return;
//           } else {
//             // toast.warning("session time out");
//             window.location.href = window.location.origin + "/authentication";
//             return;
//           }
//         }
//         if (error && error?.code === "ERR_NETWORK") {
//           return;
//         } else {
//           const originalRequest = error.config;

//           if (error?.response?.data?.invalidToken === true) {
//             sessionStorage.clear();
//             localStorage.clear();
//           }
//           if (
//             error?.response?.data?.tokenExpired === true &&
//             !originalRequest._retry
//           ) {
//             if (isRefreshing) {
//               // Token refresh is in progress, add the request to the queue
//               return new Promise((resolve, reject) => {
//                 refreshSubscribers?.push((token) => {
//                   originalRequest.headers["Authorization"] = "Bearer " + token;
//                   resolve(instance(originalRequest));
//                 });
//                 cancelTokenSource?.cancel("Request canceled due to duplicate");
//                 reject("Request canceled due to duplicate");
//               });
//             }

//             isRefreshing = true;
//             originalRequest._retry = true;

//             // Call your token refresh function and update the Authorization header
//             return refreshToken(error)
//               .then((newToken) => {
//                 originalRequest.headers["Authorization"] = "Bearer " + newToken;
//                 return instance(originalRequest);
//               })
//               .catch((refreshError) => {
//                 // Handle token refresh failure, e.g., redirect to login page
//                 return Promise.reject(refreshError);
//               })
//               .finally(() => {
//                 isRefreshing = false;
//               });
//           }
//           return Promise.reject(error);
//         }
//       }
//     );

//     const requestPromise = instance[method.toLowerCase()](
//       `${url}${
//         payload.queries ? "?" + new URLSearchParams(payload.queries) : ""
//       }`,
//       method === "delete" && payload.body
//         ? { data: payload.body }
//         : payload.body
//     );

//     inFlightRequests.set(requestKey, requestPromise);

//     const res = await requestPromise.finally(() => {
//       inFlightRequests.delete(requestKey);
//     });
//     return res;
//   } catch (error) {
//     return error?.response;
//   }
// };

// function onTokenRefreshed(newToken) {
//   if (newToken) {
//     refreshSubscribers.forEach((subscriber) => {
//       return subscriber(newToken);
//     });
//   }
//   refreshSubscribers = [];
// }

import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

let isRefreshing = false;
let refreshSubscribers = [];
let inFlightRequests = new Map();
let queuedRequests = [];

export const apiRequest = async (
  method = "get",
  url = "",
  payload = { body: null, queries: null },
  contentType = "application/json",
  uploadProgress = () => {},
  customHeader = {}
) => {
  let access_token = localStorage.getItem("auth_token");
  let refresh_token = localStorage.getItem("refreshToken");

  const requestKey = `${method.toLowerCase()}-${url}-${JSON.stringify(
    payload
  )}`;
  if (inFlightRequests.has(requestKey)) {
    return inFlightRequests.get(requestKey);
  }

  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      "Content-Type": contentType,
      Accept: contentType,
      ...customHeader,
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      uploadProgress(percentCompleted);
    },
  });

  // Inject token into request
  instance.interceptors.request.use((config) => {
    if (!customHeader?.Authorization && access_token) {
      config.headers["Authorization"] = "Bearer " + access_token;
    }
    return config;
  });

  const refreshToken = async () => {
  if (!refresh_token) {
    return Promise.reject("No refresh token");
  }

  try {
    const res = await axios.post(`${API_BASE_URL}/refreshToken`, {
      refreshToken: refresh_token,
    });

    if (res?.data?.status === 200) {
      const newAccessToken = res.data.accessToken;
      const newRefreshToken = res.data.refreshToken;

      localStorage.setItem("auth_token", newAccessToken);
      localStorage.setItem("refreshToken", newRefreshToken);

      access_token = newAccessToken;
      refresh_token = newRefreshToken;

      onTokenRefreshed(newAccessToken);

      return newAccessToken;
    } else {
      throw new Error("Session expired");
    }
  } catch (err) {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = window.location.origin + "/authentication";
    return Promise.reject(err);
  }
};

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error?.response?.data?.invalidToken && url !== "verify-token") {
        if (window.location?.pathname?.split("/").includes("admin")) {
          window.location.href = window.location.origin + "/admin/signin";
          return;
        } else {
          window.location.href = window.location.origin + "/authentication";
          return;
        }
      }

      if (error?.response?.data?.tokenExpired && !originalRequest._retry) {
        originalRequest._retry = true;

        return new Promise((resolve, reject) => {
          queuedRequests.push({ resolve, reject, request: originalRequest });

          if (!isRefreshing) {
            isRefreshing = true;
            refreshToken()
              .then((newToken) => {
                queuedRequests.forEach(({ resolve, request }) => {
                  request.headers["Authorization"] = "Bearer " + newToken;
                  resolve(instance(request));
                });
                queuedRequests = [];
              })
              .catch((err) => {
                queuedRequests.forEach(({ reject }) => reject(err));
                queuedRequests = [];
              })
              .finally(() => {
                isRefreshing = false;
              });
          }
        });
      }

      return Promise.reject(error);
    }
  );

  const requestPromise = instance[method.toLowerCase()](
    `${url}${
      payload.queries ? "?" + new URLSearchParams(payload.queries) : ""
    }`,
    method === "delete" && payload.body ? { data: payload.body } : payload.body
  );

  inFlightRequests.set(requestKey, requestPromise);

  try {
    const res = await requestPromise;
    return res;
  } catch (error) {
    return error?.response;
  } finally {
    inFlightRequests.delete(requestKey);
  }
};

function onTokenRefreshed(newToken) {
  refreshSubscribers.forEach((cb) => cb(newToken));
  refreshSubscribers = [];
}
